import React from "react";
import {Col, Row} from "antd";
import {WarningOutlined} from "@ant-design/icons";

export function NotInSubscription({iconSize = '36px', overrideTitle}) {
    // const { accessKeys } = props;
    const style = iconSize ? {
        fontSize: iconSize,
    } : {};

    return (
        <Row align="middle">
            <Col span={24} align="center">
                <p><WarningOutlined style={style} /></p>
                <h2>{overrideTitle || 'This feature is not included in your subscription.'}</h2>
            </Col>
        </Row>
    );
}
